import React from "react";
import { useState, useMemo, useEffect } from "react";

import Form from "../utils/Form";
import { privacy_policy,privacy_policy_update } from "../../actions/Setting/privacy_policy";
import { useDispatch, useSelector } from "react-redux";
import {useNavigate} from "react-router-dom"

export default function PrivacyPolicy() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [form, setForm] = useState({});

	useEffect(()=>{
		dispatch(privacy_policy())
	},[])
	const privacypolicy=useSelector((state)=>state.setting?.privacypolicy?.data[0])
	useMemo(()=>{
		setForm({...privacypolicy})
	},[privacypolicy])

	const formStructure= [
		{
			id: "1",
			type: "description",
			name:"description",
			title: "",
			limit:"10000"
		},

		
		
		{
			id: "8",
			type: "button",
			title: "Update" ,
		},
	]

	
	const handleSubmit = (event) => {
		event.preventDefault();
		const data = new FormData();
		data.append("id" , privacypolicy?.id)
		// console.log(data , privacypolicy?.id ,"newData")
		
		Object.keys(form).map((key) => data.append(key, form?.[key]));
		
		
			
		dispatch(privacy_policy_update(data));
		navigate("/Dashboard/Dashboard")
		
	};

	return (
		<>
			
				<Form
					formStructure={formStructure}
					handleSubmit={handleSubmit}
					formTitle={"Privacy Policy"}
					key={"Form"}
					setForm={setForm}
					form={form}
				/>
		
		</>
	);
}
